"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIcon = void 0;
const react_1 = __importDefault(require("react"));
const CheckIcon = () => (react_1.default.createElement("svg", { width: "13", height: "9", viewBox: "0 0 13 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, react_1.default.createElement("path", { d: "M0.879342 4.36518L4.51416 8L11.7838 0.730364", stroke: "white", strokeWidth: "1.36719", strokeLinecap: "round", strokeLinejoin: "round" })));
exports.CheckIcon = CheckIcon;
exports.default = exports.CheckIcon;
